/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TextMessageTaskCreatePriority } from './textMessageTaskCreatePriority';
import type { TextMessageTaskCreateTaskNoteDoc } from './textMessageTaskCreateTaskNoteDoc';

export interface TextMessageTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: TextMessageTaskCreatePriority;
  title?: string | null;
  type: 'text_message';
  task_note_doc?: TextMessageTaskCreateTaskNoteDoc;
}
